export default {
    urlBase: process.env.REACT_APP_MATOMO_URL ?? "",
    siteId: parseInt(process.env.REACT_APP_MATOMO_SITE_ID ?? ""),
    userId: undefined,
    trackerUrl: `${process.env.REACT_APP_MATOMO_URL ?? ""}/matomo.php`,
    srcUrl: `${process.env.REACT_APP_MATOMO_URL ?? ""}/matomo.js`,
    disabled: false,
    heartBeat: {
        active: true,
        seconds: 10,
    },
    linkTracking: false,
    configurations: {
        disableCookies: true,
        setSecureCookie: true,
        setRequestMethod: "POST",
    },
};
